function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import ErrorText from '../ErrorText';
import Description from './Description';
import FormGroup from './FormGroup';
import Select from './Select';
import Label from './Label';
const SelectFormGroup = /*#__PURE__*/memo(_ref => {
  let {
    name,
    label,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FormGroup, null, !!label && /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Field, _extends({
    name: name,
    component: Select
  }, props)), !!description && /*#__PURE__*/React.createElement(Description, null, description), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: name,
    component: ErrorText
  }));
});
SelectFormGroup.propTypes = {
  description: PropTypes.node,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  type: PropTypes.string
};
SelectFormGroup.defaultProps = {
  type: 'text'
};
SelectFormGroup.displayName = 'SelectFormGroup';
export default SelectFormGroup;